import { useFlags } from 'launchdarkly-react-client-sdk';
import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';
import { useAppSelector } from 'store/hooks';

import OldNoteEdit from './noteEdit';
import { DraftNoteForm } from './presets/DraftNoteForm';
import { PopupNoteForm } from './presets/PopupNoteForm';

export type Props = {
  note?: ClientProfileContentItem;
  clientId: string;
  isEditMode?: boolean;
  inputOpen?: boolean;
  noteId?: string;
  context: 'popup' | 'noteSection';
};

// NoteEdit component with feature flag
// Uses new composable NoteForm when enableBillingUpdates is true
export const NoteEdit = (props: Props) => {
  const { data } = useAppSelector((state) => state.clients.client);
  const { enableBillingUpdates } = useFlags();

  if (!enableBillingUpdates) {
    return <OldNoteEdit {...props} />;
  }

  if (!data?.status) return null;

  // Use new composable NoteForm based on context
  if (props.context === 'popup') {
    return <PopupNoteForm status={data?.status} clientId={props.clientId} note={props.note} />;
  }

  // Default to DraftNoteForm for noteSection context
  return (
    <DraftNoteForm
      status={data?.status}
      clientId={props.clientId}
      note={props.note}
      expanded={props.inputOpen}
      clientName={data?.firstName + ' ' + data?.lastName ?? ''}
      prependedClientId={data?.prependedId ?? ''}
      useCurrentNoteFallback
    />
  );
};
